import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AdSense from 'react-adsense';
import { useNavigate, NavLink, useParams } from "react-router-dom";
import { alert_error, alert_success } from './../../../../AppContext';
import { Cookies } from '../../../../index.js';
import { ClipLoader } from "react-spinners";
import translations from '../../translations.json';
import Language_i18 from '../../../../js/useNationalLanguage.jsx';

const InviteFriends = () => {
    const { i18n, lang } = Language_i18();

    const [nutxuly, setnutxuly] = useState(0);
    // GIỮ NGUYÊN GIÁ TRỊ TIẾNG ANH MẶC ĐỊNH
    const [nutorder, setnutorder] = useState('✔️ Click to Confirm');
    const { slug_1 } = useParams();
    const [money, setmoney] = useState('');

    // --- LOGIC GỐC (KHÔNG THAY ĐỔI) ---
    const laythongtin = (apikey, service) => {
        axios
            .post('https://hust.media/api/orders/account/sellers/shop/pay.php', { apikey, service })
            .then(response => testFunction4(response, service))
            .catch(error => console.log(123 + error));
    };
    const testFunction4 = (response, service) => {
        const info = response.data;
        if (info.money) {
            setmoney(info.money);
        }
    };
    const laydulieu = () => {
        const apiKey = Cookies.get('apikey');
        if (apiKey !== null) {
            laythongtin(apiKey, 'getmoney');
        } else {
            console.log('Không có API key.');
        }
    };
    useEffect(() => {
        laydulieu();
    }, []);

    // SỬA CÁC HÀM ĐỂ DỊCH CÁC PHẦN TIẾNG VIỆT
    function handleSubmit(event) {

        // setnutxuly(0);
        // const apikey = Cookies.get('apikey');
        // event.preventDefault();

        // setnutxuly(1);
        // // Giữ nguyên tiếng Anh
        // setnutorder('Please wait a moment 😊'); 
        // if (!apikey) {
        //     // Chỉ dịch phần tiếng Việt
        //     alert_error(lang === 'vi' ? translations.vi.fillAllInfoError : 'Please fill in all information');
        //     setnutxuly(0);
        //     setnutorder(lang === 'vi' ? translations.vi.fillInfoButton : 'Fill in info');
        //     return;
        // }
        // axios
        //     .post('https://hust.media/jop/referral/pay.php', { apikey })
        //     .then(response => (testFunction(response)))
        //     .catch(error => console.log(error));
    };

    function testFunction(response) {
        const info = response.data;
        const status = info.status;
        // Chỉ dịch phần tiếng Việt
        setnutorder(lang === 'vi' ? translations.vi.orderAgain : 'Order again');
        setnutxuly(0);
        if (status == 0) {
            alert_error(info.message);
        } else if (status == 1) {
            alert_success(info.message);
        }
        if (info.redirect != null && info.redirect != '') {
            setTimeout(function () {
                window.location.href = info.redirect;
            }, 1700);
        }
    };

    // Thêm kiểm tra nếu `lang` chưa sẵn sàng để tránh lỗi
    if (!lang) {
        return <div style={{ textAlign: "center" }} className="mt-4"><ClipLoader size={90} color="#8a2be2" /></div>;
    }

    return (
        <div className="mt-2 mx-2">
            {!money ? (<>
                <div style={{ textAlign: "center" }} className="mt-4 justify-center items-center">
                    <ClipLoader size={90} color="#8a2be2" />
                </div>
            </>) : (<>
                <div className="max-w-xl mt-2 mx-2 mx-auto">
                    <div className="bg-white p-2 rounded-md shadow-md ">
                        <div className="bg-gray-100 rounded-md shadow-md border-1 border-purple-300">
                            {/* DÙNG LOGIC KIỂM TRA `lang` ĐỂ DỊCH */}
                            <div className="text-base mt-2 text-center font-semibold">
                                {lang === 'vi' ? translations.vi.mmoBalance : 'Referral Balance:'}
                            </div>
                            <div className="mb-2 text-center text-lg text-purple-700">{money} Coins</div>
                        </div>
                    </div>
                    <form className="mt-2 mb-1 add-form">
                        <div className="form-control">
                            <div className="mx-2">
                                <label className="mt-1 text-base">
                                    {lang === 'vi' ? translations.vi.mmowithdrawalConditions : 'To receive referral Coins, you need to transfer the referral balance to the main balance. Conditions: Minimum 10k Coins and refer at least 7 people.'}
                                </label>
                                <button disabled={nutxuly == 1}
                                    onClick={handleSubmit}
                                    className='mt-3 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-2 w-full dark:bg-slate-800 dark:text-white'>
                                    <div className='flex items-center justify-between flex-1'>
                                        {nutxuly == 1 &&
                                            <div className="spinner-border" role="status">
                                            </div>}
                                        <span className='text-lg font-medium text-white'>
                                            {nutorder}</span>
                                        <div className="text-xl">
                                            {'\u27A4'}
                                        </div>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </form>
                    <div className="cards">
                        <AdSense.Google
                            client="ca-pub-4574266110812955"
                            slot="3259681051"
                            style={{ display: 'block' }}
                            format="auto"
                            responsive="true"
                        /></div>
                </div>
            </>)}
        </div>
    );
};

export default InviteFriends;